import * as React from 'react';
import { Badge, Text } from '@theme-ui/components';
import {
  IconCedroAustraliano,
  IconEucalipto,
  IconMognoAfricano,
  IconPinus,
  IconTeca,
  IconType,
} from '../Icons';
import type { SpecieName } from '../../types/SpecieName';

export type SpecieType = {
  name: SpecieName;
  selected?: boolean;
};

type Specie = {
  [specieName in SpecieName]: {
    color: string;
    name: SpecieName;
    icon: React.VoidFunctionComponent<IconType>;
  };
};

export const SPECIE_ATTRIBUTES: Specie = {
  'Cedro Australiano': {
    color: 'cedroAustraliano',
    name: 'Cedro Australiano',
    icon: IconCedroAustraliano,
  },
  Eucalipto: {
    color: 'eucalipto',
    name: 'Eucalipto',
    icon: IconEucalipto,
  },
  'Mogno Africano': {
    color: 'mognoAfricano',
    name: 'Mogno Africano',
    icon: IconMognoAfricano,
  },
  Pinus: {
    color: 'pinus',
    name: 'Pinus',
    icon: IconPinus,
  },
  Teca: {
    color: 'teca',
    name: 'Teca',
    icon: IconTeca,
  },
};

type SpecieBadgeProps = {
  code: string;
  species?: SpecieName;
};

const SpecieBadge = ({ code, species }: SpecieBadgeProps) => {
  const Icon = species && SPECIE_ATTRIBUTES[species]?.icon;
  const backgroundColor = species
    ? SPECIE_ATTRIBUTES[species]?.color
    : undefined;

  return (
    <Badge
      sx={{
        backgroundColor,
        borderRadius: '500px',
        paddingX: 6,
        paddingY: 4,
        display: 'flex',
        alignItems: 'center',
        marginTop: 5,
      }}
    >
      {Icon && <Icon width={10} height="21px" color="white" />}
      <Text
        sx={{
          marginLeft: Icon ? 5 : 0,
          fontSize: 3,
          fontFamily: 'body',
          fontWeight: 'body',
        }}
      >
        {code}
      </Text>
    </Badge>
  );
};

export default SpecieBadge;
